import { render, staticRenderFns } from "./BaseTimer.vue?vue&type=template&id=82357ac8&"
import script from "./BaseTimer.vue?vue&type=script&lang=js&"
export * from "./BaseTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/vuejs/project/school/arrisalah/ppdb/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VProgressCircular})
